import type { ZapiAction } from '@weft/zapi-types';
import { PAGINATION_QUERY_PARAMETERS, SEARCH_QUERY_PARAMETER } from '../../../api-definition-params';
import { GET_CUSTOMER_OVERVIEWS_PATH } from './get-customers-overviews-path';
import { GetCustomersOverviewsResponseSchema } from './get-customers-overviews-response-schema';

export const GET_CUSTOMERS_OVERVIEWS_ACTION = {
  method: 'get',
  codeGenerationSettings: {
    actionText: 'get-customers-overviews',
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
  },
  response: {
    name: 'GetCustomersOverviewsResponse',
    schema: GetCustomersOverviewsResponseSchema,
  },
  path: GET_CUSTOMER_OVERVIEWS_PATH,
} satisfies ZapiAction;

export type GetCustomersOverviewsAction = typeof GET_CUSTOMERS_OVERVIEWS_ACTION;